import { Flex, FlexProps } from '@chakra-ui/react'

//@ts-ignore
interface IProps extends FlexProps {
  left?: React.ReactElement
  center?: React.ReactElement
  right?: React.ReactElement
  dataTestId?: string
  rest?: FlexProps
}

export const Header = ({
  left,
  center,
  right,
  dataTestId,
  ...rest
}: IProps) => {
  return (
    <Flex
      alignItems='center'
      bgColor='white'
      borderBottom='1px solid #D5DCE4'
      data-testid={dataTestId}
      h='65px'
      justifyContent='space-between'
      pos='relative'
      zIndex='10'
      {...rest}
    >
      {left && <Flex flexGrow={1}>{left}</Flex>}
      {center && (
        <Flex flexGrow={1} justifyContent='center'>
          {center}
        </Flex>
      )}
      {right && (
        <Flex
          alignItems='center'
          flexGrow={1}
          h='full'
          justifyContent='flex-end'
        >
          {right}
        </Flex>
      )}
    </Flex>
  )
}
